import { NumericalColumn, StringColumn, BooleanColumn } from 'baseui/data-table';
import { CustomDateColumn, EMPTY_STRING, EMPTY_NUMBER } from 'commons-ui';
import { WebsiteUpdateDashboardBucketsList } from 'constant';

export const COL_NAMES = {
	websiteName: 'websiteName',
	dashBoardName: 'dashBoardName',
	isActive: 'isActive',
	deployedAt: 'deployedAt',
	deployedBy: 'deployedBy',
	createdAt: 'createdAt',
	buckets: 'buckets'
};

export const columnConfigs = [
	StringColumn({
		title: 'Website Name',
		mapDataToValue: (data: any) => data[COL_NAMES.websiteName]
	}),
	StringColumn({
		title: 'Dashboard Name',
		mapDataToValue: (data: any) => data[COL_NAMES.dashBoardName] || EMPTY_STRING
	}),
	NumericalColumn({
		title: 'Control Version Number',
		mapDataToValue: (data: any) => {
			const websiteUpdateDashboardBucketsData = data[COL_NAMES.buckets]?.find(
				(bucket: any) => bucket.name === WebsiteUpdateDashboardBucketsList.CONTROL
			);
			return websiteUpdateDashboardBucketsData?.versionNumber || EMPTY_NUMBER;
		}
	}),
	NumericalColumn({
		title: 'Control Share',
		mapDataToValue: (data: any) => {
			const websiteUpdateDashboardBucketsData = data[COL_NAMES.buckets]?.find(
				(bucket: any) => bucket.name === WebsiteUpdateDashboardBucketsList.CONTROL
			);
			return websiteUpdateDashboardBucketsData?.share || EMPTY_NUMBER;
		}
	}),
	StringColumn({
		title: 'Control Description',
		mapDataToValue: (data: any) => {
			const websiteUpdateDashboardBucketsData = data[COL_NAMES.buckets]?.find(
				(bucket: any) => bucket.name === WebsiteUpdateDashboardBucketsList.CONTROL
			);
			return websiteUpdateDashboardBucketsData?.description || EMPTY_STRING;
		}
	}),
	NumericalColumn({
		title: 'Test_1 Version Number',
		maxWidth: 200,
		mapDataToValue: (data: any) => {
			const websiteUpdateDashboardBucketsData = data[COL_NAMES.buckets]?.find(
				(bucket: any) => bucket.name === WebsiteUpdateDashboardBucketsList.TEST_1
			);
			return websiteUpdateDashboardBucketsData?.versionNumber || EMPTY_NUMBER;
		}
	}),
	NumericalColumn({
		title: 'Test_1 Share',
		mapDataToValue: (data: any) => {
			const websiteUpdateDashboardBucketsData = data[COL_NAMES.buckets]?.find(
				(bucket: any) => bucket.name === WebsiteUpdateDashboardBucketsList.TEST_1
			);
			return websiteUpdateDashboardBucketsData?.share || EMPTY_NUMBER;
		}
	}),
	StringColumn({
		title: 'Test_1 Description',
		mapDataToValue: (data: any) => {
			const websiteUpdateDashboardBucketsData = data[COL_NAMES.buckets]?.find(
				(bucket: any) => bucket.name === WebsiteUpdateDashboardBucketsList.TEST_1
			);
			return websiteUpdateDashboardBucketsData?.description || EMPTY_STRING;
		}
	}),
	NumericalColumn({
		title: 'Test_2 Version Number',
		maxWidth: 200,
		mapDataToValue: (data: any) => {
			const websiteUpdateDashboardBucketsData = data[COL_NAMES.buckets]?.find(
				(bucket: any) => bucket.name === WebsiteUpdateDashboardBucketsList.TEST_2
			);
			return websiteUpdateDashboardBucketsData?.versionNumber || EMPTY_NUMBER;
		}
	}),
	NumericalColumn({
		title: 'Test_2 Share',
		mapDataToValue: (data: any) => {
			const websiteUpdateDashboardBucketsData = data[COL_NAMES.buckets]?.find(
				(bucket: any) => bucket.name === WebsiteUpdateDashboardBucketsList.TEST_2
			);
			return websiteUpdateDashboardBucketsData?.share || EMPTY_NUMBER;
		}
	}),
	StringColumn({
		title: 'Test_2 Description',
		mapDataToValue: (data: any) => {
			const websiteUpdateDashboardBucketsData = data[COL_NAMES.buckets]?.find(
				(bucket: any) => bucket.name === WebsiteUpdateDashboardBucketsList.TEST_2
			);
			return websiteUpdateDashboardBucketsData?.description || EMPTY_STRING;
		}
	}),
	StringColumn({
		title: 'Bucket Details',
		maxWidth: 4000,
		minWidth: 100,
		mapDataToValue: (data: any) => {
			const otherBuckets = data[COL_NAMES.buckets]?.filter(
				(bucket: any) => !Object.values(WebsiteUpdateDashboardBucketsList).includes(bucket.name)
			);
			if (!otherBuckets?.length) return EMPTY_STRING;
			return otherBuckets.map(
				(bucket: any) => `${bucket.name} (v${bucket.versionNumber}, ${bucket.share}, ${bucket.description}%)`
			);
		}
	}),
	StringColumn({
		title: 'Deployed By',
		mapDataToValue: (data: any) => data[COL_NAMES.deployedBy] || EMPTY_STRING
	}),
	BooleanColumn({
		title: 'Is Active',
		mapDataToValue: (data: any) => data[COL_NAMES.isActive]
	}),
	CustomDateColumn({
		title: 'Deployed At',
		minWidth: 250,
		maxWidth: 400,
		columnName: COL_NAMES.deployedAt
	}),
	CustomDateColumn({
		title: 'Created At',
		minWidth: 150,
		maxWidth: 200,
		columnName: COL_NAMES.createdAt
	})
];
